import { PropsWithChildren } from "react";
import { ClientPermissionsContext, Props } from "./ClientPermissionsContext";

export const ClientPermissionsContextProvider = ({
  permissions,
  permissionSets,
  children,
}: PropsWithChildren<Props>) => (
  <ClientPermissionsContext.Provider
    value={{
      permissions,
      permissionSets,
      hasAnyPermission: (values: string[]) => {
        return permissions.some((p) => values.includes(p));
      },
      hasAnyPermissionForClient: (clientCode: string, values: string[]) => {
        const clientPermissions = permissionSets.find((p) => p.clientCode === clientCode);
        if (!clientPermissions) return false;
        return clientPermissions.permissions.some((p) => values.includes(p));
      },
    }}
  >
    {children}
  </ClientPermissionsContext.Provider>
);
